"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _functional_utility = require("../../../../packages/common-utilities/src/functional_utility");

var _card_component = require("../global_components/card_component");

var _card_component2 = _interopRequireDefault(_card_component);

var _date_formatter = require("../../../../packages/common-utilities/src/date_formatter");

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _ic_growth_of_hypo_chart = require("./ic_growth_of_hypo_chart");

var _ic_growth_of_hypo_chart2 = _interopRequireDefault(_ic_growth_of_hypo_chart);

var _ramda = require("ramda");

var _date_range_dropdown = require("../global_components/date_range_dropdown");

var _date_range_dropdown2 = _interopRequireDefault(_date_range_dropdown);

var _collection_utility = require("../../../../packages/common-utilities/src/collection_utility");

var _accessibility_utility = require("../../../../packages/common-utilities/src/accessibility_utility");

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

var _string_utility = require("../../../../packages/common-utilities/src/string_utility");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _tracking_utility = require("../../../../packages/common-utilities/src/tracking_utility");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _button = require("../global_components/button");

var _button2 = _interopRequireDefault(_button);

var _funds_repository = require("../../repository/funds_repository");

var _funds_repository2 = _interopRequireDefault(_funds_repository);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDateFromObject = function getDateFromObject(data) {
    var pathToDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "date";
    return (0, _ramda.path)([pathToDate], data);
};

var createPlotPointsForChart = function createPlotPointsForChart(growthOf10KData) {
    var dataFor1 = (0, _ramda.isNil)(growthOf10KData[0]) ? [] : growthOf10KData[0].timeSeries;
    var dataFor2Available = !(0, _ramda.isNil)(growthOf10KData[1]);
    var dataFor3Available = !(0, _ramda.isNil)(growthOf10KData[2]);
    var plotPoints = [];
    var newPlotPoint = void 0;
    for (var i = 0; i < dataFor1.length; i++) {
        newPlotPoint = {
            shareclassAmount1: parseInt(dataFor1[i].value),
            shareclassAmount2: dataFor2Available ? parseInt(growthOf10KData[1].timeSeries[i].value) : null,
            shareclassAmount3: dataFor3Available ? parseInt(growthOf10KData[2].timeSeries[i].value) : null,
            date: dataFor1[i].date,
            formattedDate: i === 0 ? _date_formatter2.default.getDateInSlashFormat((0, _moment2.default)(dataFor1[i].date).subtract(1, "days").format("yyyy-MM-DD")) : _date_formatter2.default.getDateInSlashFormat(dataFor1[i].date)
        };
        plotPoints.push(newPlotPoint);
    }
    return plotPoints;
};

var getDefaultOptionValue = function getDefaultOptionValue(growthOf10KMonthEnds) {
    if (!(0, _functional_utility.isNilOrEmpty)(growthOf10KMonthEnds)) {
        return growthOf10KMonthEnds[0];
    }
};

var ICGrowthOfHypoChartParent = function (_React$Component) {
    _inherits(ICGrowthOfHypoChartParent, _React$Component);

    function ICGrowthOfHypoChartParent(props) {
        _classCallCheck(this, ICGrowthOfHypoChartParent);

        var _this = _possibleConstructorReturn(this, (ICGrowthOfHypoChartParent.__proto__ || Object.getPrototypeOf(ICGrowthOfHypoChartParent)).call(this, props));

        _this.getDateRangeArray = _this.getDateRangeArray.bind(_this);
        _this.dateRangeItems = _this.dateRangeItems.bind(_this);
        _this.generateDateRangeRow = _this.generateDateRangeRow.bind(_this);
        _this.renderDateRangeDropdown = _this.renderDateRangeDropdown.bind(_this);
        _this.renderChartLegend = _this.renderChartLegend.bind(_this);
        _this.setRef = _this.setRef.bind(_this);
        _this.setDateFilter = _this.setDateFilter.bind(_this);
        _this.trackChartDownload = _this.trackChartDownload.bind(_this);
        _this.plotPoints = createPlotPointsForChart(_this.props.growthOf10KData);
        _this['dropdown-label-dateRange'] = { 'text': 'Since Inception' };
        _this.state = {
            selectedDateOption: "Since Inception",
            selectedDateOptionValue: getDefaultOptionValue(_this.props.growthOf10KMonthEnds),
            filteredData: null,
            numberOfProducts: 1
        };
        return _this;
    }

    _createClass(ICGrowthOfHypoChartParent, [{
        key: "trackChartDownload",
        value: function trackChartDownload(fileName) {
            if (!fileName) {
                return;
            }
            _tracking_utility.TrackingUtility.trackEvent({
                'event': 'gaEvent',
                'eventCategory': 'investment comparison modal',
                'eventAction': 'download',
                'eventLabel': "" + fileName
            });
        }
    }, {
        key: "formatDownloadXlsFileName",
        value: function formatDownloadXlsFileName() {
            var fileName = "Growth of 10K ";
            this.props.stats.forEach(function (data) {
                fileName += data.funds[0].ticker + "-";
            });
            fileName += "(AS-OF-" + _date_formatter2.default.getDateInSlashFormat(this.props.growthOf10KPeriodView.to, "MM-DD-YYYY") + ").xlsx";
            return fileName;
        }
    }, {
        key: "renderChartLegend",
        value: function renderChartLegend(propsStats, disabledIndex) {
            var _this2 = this;

            var items = [];
            propsStats.forEach(function (stats, index) {
                var className = 'ic-ticker-dot';
                var tagClass = "tag chart-legend display-inline-block";
                if (index === 1) {
                    className = 'ic-ticker-rectangle';
                    tagClass += ' padding-left-20';
                } else if (index === 2) {
                    className = 'ic-ticker-triangle';
                    tagClass += ' padding-left-20';
                }
                if (disabledIndex[index]) {
                    className += '-disabled';
                }
                items.push(_this2.renderLegend(tagClass, className, stats, disabledIndex[index]));
            });
            return _react2.default.createElement(
                "div",
                { "data-testid": "ic-performance-chart-legend-container", className: "font-light font-16 padding-top-10 padding-bottom-24" },
                items
            );
        }
    }, {
        key: "renderLegend",
        value: function renderLegend(tagClass, className, stats, disabled) {
            return _react2.default.createElement(
                "div",
                { className: tagClass },
                _react2.default.createElement("div", { className: className + " ic-icon" }),
                _react2.default.createElement(
                    "span",
                    { "data-testId": "ic-performance-chart-legend", className: "caption font-regular", style: { "font-weight": 100, "vertical-align": "middle;" } },
                    stats.funds[0].ticker
                ),
                disabled && _react2.default.createElement("div", { className: "ic-exclaim ic-icon" })
            );
        }
    }, {
        key: "renderYoungFundDisclosure",
        value: function renderYoungFundDisclosure(disabledIndex) {
            if (!_collection_utility.CollectionUtility.includes(disabledIndex, true)) {
                return null;
            }
            return _react2.default.createElement(
                "div",
                { "data-testId": "ic-young-fund-disclaimer", className: "ic-young-fund-disclaimer" },
                _react2.default.createElement("span", { className: "ic-exclaim ic-icon" }),
                "Fund has insufficient historical data"
            );
        }
    }, {
        key: "setRef",
        value: function setRef(refId) {
            var _this3 = this;

            return function (el) {
                return _this3[refId] = el;
            };
        }
    }, {
        key: "getDateRangeArray",
        value: function getDateRangeArray() {
            var _this4 = this;

            var dateRangeArray = [];
            var yearMapArray = [{ years: 0, value: '' }, { years: 1, value: '11' }, { years: 3, value: '35' }, { years: 5, value: '59' }, { years: 10, value: '119' }];
            if (!(0, _functional_utility.isNilOrEmpty)(this.props.growthOf10KMonthEnds)) {
                this.props.growthOf10KMonthEnds.forEach(function (monthEndDate, index) {
                    if (!(0, _ramda.isNil)(yearMapArray[index])) {
                        if (index === 0) {
                            dateRangeArray.push({
                                value: monthEndDate,
                                displayValue: _this4.props.figiIds.length === 1 ? 'Since Inception' : 'Common Inception',
                                translationKey: _this4.props.figiIds.length === 1 ? 'dropdown-since-inception' : 'dropdown-common-inception'
                            });
                        } else {
                            dateRangeArray.push({
                                value: monthEndDate,
                                displayValue: 'Last ' + yearMapArray[index].years + ' year' + (yearMapArray[index].years > 1 ? 's' : ''),
                                translationKey: 'dropdown-last-' + yearMapArray[index].years + '-year' + (yearMapArray[index].years > 1 ? 's' : '')
                            });
                        }
                    }
                });
            }
            return dateRangeArray;
        }
    }, {
        key: "dateRangeItems",
        value: function dateRangeItems() {
            var _this5 = this;

            var dateRangeArray = this.getDateRangeArray();

            var items = (0, _ramda.addIndex)(_ramda.map)(function (dateRangeOption, index) {
                return _this5.generateDateRangeRow(dateRangeOption.value, dateRangeOption.displayValue, dateRangeOption.translationKey, index);
            }, dateRangeArray);

            return items;
        }
    }, {
        key: "setDateFilter",
        value: function setDateFilter(event) {
            var _this6 = this;

            var filteredData = void 0;
            var dateOption = 0;
            var target = (0, _ramda.isNil)(event.target.getAttribute('data-option-value')) ? event.target.parentNode : event.target;

            _tracking_utility.TrackingUtility.trackEvent({
                "eventCategory": "pdp",
                "eventAction": "ic growth of hypothetical investment chart",
                "eventLabel": target.getAttribute("data-display-value")
            });

            this['dropdown-label-dateRange'].text = target.getAttribute('data-display-value');
            dateOption = target.getAttribute('data-option-value');
            _funds_repository2.default.getICLiteProductData(this.props.country, this.props.language, this.props.role, this.props.currency, this.props.gaiaRedirectUrl + '/ic-growth-of-hypo', this.props.figiIds, dateOption).then(function (icFundState) {
                var growthOf10KData = [];
                icFundState.comparisonData.forEach(function (dataObj) {
                    if (!(0, _ramda.isNil)(dataObj.growthOf10K)) {
                        growthOf10KData.push(dataObj.growthOf10K);
                    } else {
                        growthOf10KData.push(null);
                    }
                });
                filteredData = createPlotPointsForChart(growthOf10KData);
                var numberOfProducts = growthOf10KData.length;
                _this6.setState({
                    selectedDateOptionValue: dateOption,
                    selectedDateOption: target.getAttribute('data-display-value'),
                    selectedDateOptionTranslateKey: target.getAttribute('data-translation-key'),
                    filteredData: filteredData,
                    numberOfProducts: numberOfProducts
                });
            }, function () {
                _this6.setState({ icMessageStatus: 'ic error' });
            });
        }
    }, {
        key: "generateDateRangeRow",
        value: function generateDateRangeRow(value, displayValue, translationKey, key) {
            var _this7 = this;

            this[value + "dropdown"] = _react2.default.createRef();
            var isLastElement = value === "custom";
            return _react2.default.createElement(
                "div",
                { key: key,
                    tabIndex: 0,
                    "data-option-value": value,
                    "data-translation-key": translationKey,
                    "data-display-value": displayValue,
                    ref: this[value + "dropdown"],
                    "aria-selected": "" + (this.state.selectedDateOption === displayValue ? "true" : "false"),
                    onKeyDown: function onKeyDown(event) {
                        return _accessibility_utility2.default.handleDropdownEvents(_this7, event, '#card-component-' + _this7.props.id + ' #dateRangeFilter', value + "dropdown", '0dropdown', isLastElement, function () {
                            return _this7.setDateFilter(event);
                        });
                    },
                    onClick: this.setDateFilter, className: "dropdown-list-item", role: "option" },
                _react2.default.createElement(
                    "span",
                    { className: "font-light caption", "data-option-value": value,
                        "data-translation-key": translationKey, "data-display-value": displayValue },
                    _string_utility2.default.renderFormattedLabel(displayValue, translationKey)
                )
            );
        }
    }, {
        key: "renderDateRangeDropdown",
        value: function renderDateRangeDropdown() {
            return _react2.default.createElement(_date_range_dropdown2.default, {
                dateRangeItems: this.dateRangeItems,
                setRef: this.setRef,
                parentProps: this.props,
                state: this.state,
                additionalClassName: "ic-chart-date-range"
            });
        }
    }, {
        key: "renderHeader",
        value: function renderHeader(key, defaultTitle, asOfDate) {
            return _react2.default.createElement(
                "div",
                { className: "row" },
                _react2.default.createElement(
                    "div",
                    { className: "col-md-6 col-lg-6 col-xlg-6" },
                    _react2.default.createElement(
                        "h3",
                        { className: "sub-header-2", "data-testId": key },
                        _string_utility2.default.renderFormattedLabel(defaultTitle, key + "-title"),
                        " ",
                        _react2.default.createElement(
                            "span",
                            { className: "category" },
                            _string_utility2.default.renderFormattedLabel("As of", "label-for-as-of"),
                            " ",
                            asOfDate
                        )
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { "data-testid": "customDateRangeComponent", className: "font-regular tag col-md-6 col-lg-6 col-xlg-6 display-inline" },
                    this.renderDateRangeDropdown()
                )
            );
        }
    }, {
        key: "render",
        value: function render() {
            var _this8 = this;

            if ((0, _functional_utility.isNilOrEmpty)(this.props.growthOf10KData)) {
                return null;
            }
            var ticker1 = this.props.figiIds[0];
            var ticker2 = (0, _functional_utility.isNilOrEmpty)(this.props.figiIds[1]) ? 'null' : this.props.figiIds[1];
            var ticker3 = (0, _functional_utility.isNilOrEmpty)(this.props.figiIds[2]) ? 'null' : this.props.figiIds[2];

            var excelServiceURL = encodeURI(this.props.gaiaRedirectUrl + '/excel?' + '&type=icLite' + '&ticker1=' + ticker1 + '&ticker2=' + ticker2 + '&ticker3=' + ticker3 + '&country=' + this.props.country + '&language=' + this.props.language + '&role=' + this.props.role + '&currency=' + this.props.currency + '&fromDate=' + getDateFromObject(this.state.filteredData[0]) + '&toDate=' + getDateFromObject((0, _ramda.last)(this.state.filteredData)));

            this.plotPoints = createPlotPointsForChart(this.props.growthOf10KData);
            var fileName = this.formatDownloadXlsFileName();
            return _react2.default.createElement(
                "div",
                { className: "ic-chart-parent" },
                _react2.default.createElement(
                    _card_component2.default,
                    {
                        headerTitle: null,
                        headerTitleId: "ic-growth-of-10k",
                        headerTitleLabel: "ic-growth-of-10k-header",
                        placementId: "icLiteGrowth10k",
                        disclosureText: [this.props.disclosure],
                        breakpoint: this.props.breakpoint,
                        hideCardBorder: true,
                        headerLabel: this.renderHeader("ic-growth-of-10k-title", "Growth of $10k", _date_formatter2.default.getDateInSlashFormat(this.props.growthOf10KPeriodView.to)),
                        ariaLabel: "Read more about Growth of $10k"
                    },
                    this.renderChartLegend(this.props.stats, this.props.disabledIndex),
                    this.renderYoungFundDisclosure(this.props.disabledIndex),
                    _react2.default.createElement(_ic_growth_of_hypo_chart2.default, {
                        plotPoints: this.state.filteredData,
                        stats: this.props.stats,
                        breakpoint: this.props.breakpoint,
                        visibleDataPoints: [],
                        currencyCode: "$",
                        numberFormat: this.props.numberFormat,
                        disabledIndex: this.props.disabledIndex
                    }),
                    _react2.default.createElement(_button2.default, {
                        role: this.props.role,
                        dataTest: "download-data",
                        downloadURL: excelServiceURL,
                        dataTestLink: "ic-performance-chart-excel-download-link",
                        text: _string_utility2.default.renderFormattedLabel('Download data table', 'pdp-ic-download-chart-data', { role: this.props.role }),
                        additionalClassName: "mobile-full-width float-right",
                        callBack: function callBack() {
                            return _this8.trackChartDownload(fileName);
                        },
                        ariaLabel: "Download data table"
                    })
                )
            );
        }
    }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(props, state) {
            var derivedState = state;
            var dateOption = props.figiIds.length === 1 ? 'Since Inception' : 'Common Inception';
            if (!(0, _functional_utility.isNilOrEmpty)(props.growthOf10KData) && (0, _ramda.isNil)(state.filteredData)) {
                var plotPoints = createPlotPointsForChart(props.growthOf10KData);
                derivedState = _extends({}, derivedState, {
                    filteredData: plotPoints,
                    selectedDateOption: dateOption,
                    numberOfProducts: props.figiIds.length
                });
            }
            if (!(0, _functional_utility.isNilOrEmpty)(props.growthOf10KData) && !(0, _ramda.isNil)(state.filteredData) && props.figiIds.length !== state.numberOfProducts) {
                var _plotPoints = createPlotPointsForChart(props.growthOf10KData);
                derivedState = _extends({}, derivedState, { filteredData: _plotPoints, selectedDateOption: dateOption, selectedDateOptionValue: getDefaultOptionValue(props.growthOf10KMonthEnds), numberOfProducts: props.figiIds.length });
            }
            return derivedState;
        }
    }]);

    return ICGrowthOfHypoChartParent;
}(_react2.default.Component);

exports.default = ICGrowthOfHypoChartParent;